import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import ScheduleIcon from "@mui/icons-material/Schedule";
import TuneIcon from "@mui/icons-material/Tune";
import CategoryIcon from "@mui/icons-material/Category";
import CircularProgress from "@mui/material/CircularProgress";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { useNavigate } from "react-router-dom";

import ExamExternalSchedule from "./ExamExternalSchedule";
import ExamTimeTable from "./ExamTimeTable";
import ExamCourseAllotment from "./ExamCourseAllotment";
import ExamPaperTemplate from "./ExamPaperTemplate";
import StaffExternal from "./StaffExternal";
import CourseMasterReport from "./CourseMasterReport";
import CourseRegulationReport from "./CourseRegulationReport";
import RoomCapacitySummary from "./RoomCapacitySummary";
import ScriptValuation from "./ScriptValuation";
function Exams() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [loading, setLoading] = useState(true);
  const [activeView, setActiveView] = useState("home");
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(false);
  }, []);

  const getAuthHeaders = () => {
    const token = sessionStorage.getItem("token");
    return {
      Authorization: `Bearer ${token}`,
    };
  };

  const handleNavigate = (path) => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      navigate("/authentication/sign-in");
    } else {
      setActiveView(path);
    }
  };

  const handleBack = () => {
    setActiveView("home");
  };

  const renderContent = () => {
    switch (activeView) {
      case "examcourse":
        return (
          <>
            <ExamCourseAllotment />
          </>
        );
      case "examschedule":
        return (
          <>
            <ExamExternalSchedule />
          </>
        );
      case "examtimetable":
        return (
          <>
            <ExamTimeTable />
          </>
        );
      case "exampapertemplate":
        return (
          <>
            <ExamPaperTemplate />
          </>
        );
      case "staffexternal":
        return (
          <>
            <StaffExternal />
          </>
        );

      case "coursemasterreport":
        return (
          <>
            <CourseMasterReport />
          </>
        );
      case "courseregulationreport":
        return (
          <>
            <CourseRegulationReport />
          </>
        );
      case "roomcapacity":
        return (
          <>
            <RoomCapacitySummary />
          </>
        );
      case "scriptvaluation":
        return (
          <>
            <ScriptValuation />
          </>
        );
      default:
        return (
          <Grid container spacing={3}>
            <Grid item xs={12} sm={2} mx={1} mt={2} py={1} px={2}>
              <MDButton
                fullWidth
                color="info"
                variant="gradient"
                size="large"
                sx={{ width: 200, height: "90px", fontSize: "1rem" }}
                startIcon={<CategoryIcon />}
                onClick={() => handleNavigate("examcourse")}
              >
                COURSE ALLOTMENT
              </MDButton>
            </Grid>
            <Grid item xs={12} sm={2} mx={1} mt={2} py={1} px={2}>
              <MDButton
                fullWidth
                color="info"
                variant="gradient"
                size="large"
                sx={{ width: 200, height: "90px", fontSize: "1rem" }}
                startIcon={<CategoryIcon />}
                onClick={() => handleNavigate("examschedule")}
              >
                EXAM SCHEDULE
              </MDButton>
            </Grid>
            <Grid item xs={12} sm={2} mx={1} mt={2} py={1} px={2}>
              <MDButton
                fullWidth
                color="info"
                variant="gradient"
                size="large"
                sx={{ width: 200, height: "90px", fontSize: "1rem" }}
                startIcon={<CategoryIcon />}
                onClick={() => handleNavigate("examtimetable")}
              >
                EXAM TIMETABLES
              </MDButton>
            </Grid>
            <Grid item xs={12} sm={2} mx={1} mt={2} py={1} px={2}>
              <MDButton
                fullWidth
                color="info"
                variant="gradient"
                size="large"
                sx={{ width: 200, height: "90px", fontSize: "1rem" }}
                startIcon={<CategoryIcon />}
                onClick={() => handleNavigate("exampapertemplate")}
              >
                EXAM PAPER TEMPLATE
              </MDButton>
            </Grid>
            <Grid item xs={12} sm={2} mx={1} mt={2} py={1} px={2}>
              <MDButton
                fullWidth
                color="info"
                variant="gradient"
                size="large"
                sx={{ width: 200, height: "90px", fontSize: "1rem" }}
                startIcon={<CategoryIcon />}
                onClick={() => handleNavigate("staffexternal")}
              >
                EXTERENAL STAFF
              </MDButton>
            </Grid>
            <Grid item xs={12} sm={2} mx={1} mt={2} py={1} px={2}>
              <MDButton
                fullWidth
                color="info"
                variant="gradient"
                size="large"
                sx={{ width: 200, height: "90px", fontSize: "1rem" }}
                startIcon={<Icon>people_alt</Icon>}
                onClick={() => handleNavigate("coursemasterreport")}
              >
                COURSE MASTER REPORT
              </MDButton>
            </Grid>
            <Grid item xs={12} sm={2} mx={1} mt={2} py={1} px={2}>
              <MDButton
                fullWidth
                color="info"
                variant="gradient"
                size="large"
                sx={{ width: 200, height: "90px", fontSize: "1rem" }}
                startIcon={<Icon>people_alt</Icon>}
                onClick={() => handleNavigate("courseregulationreport")}
              >
                COURSE REGULATION REPORT
              </MDButton>
            </Grid>
            <Grid item xs={12} sm={2} mx={1} mt={2} py={1} px={2}>
              <MDButton
                fullWidth
                color="info"
                variant="gradient"
                size="large"
                sx={{ width: 200, height: "90px", fontSize: "1rem" }}
                startIcon={<Icon>people_alt</Icon>}
                onClick={() => handleNavigate("roomcapacity")}
              >
                ROOM CAPACITY
              </MDButton>
            </Grid>
            <Grid item xs={12} sm={2} mx={1} mt={2} py={1} px={2}>
              <MDButton
                fullWidth
                color="info"
                variant="gradient"
                size="large"
                sx={{ width: 200, height: "90px", fontSize: "1rem" }}
                startIcon={<Icon>people_alt</Icon>}
                onClick={() => handleNavigate("scriptvaluation")}
              >
                SCRIPT VALUATION
              </MDButton>
            </Grid>
          </Grid>
        );
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={2} pb={3}>
        {loading ? (
          <MDBox display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
            <CircularProgress color="info" />
          </MDBox>
        ) : (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-1}
                  py={1}
                  px={2}
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="info"
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <MDTypography variant="h6" color="white">
                    MANAGE EXAMS
                  </MDTypography>
                  {activeView !== "home" && (
                    <MDButton
                      variant="contained"
                      coloredShadow="info"
                      onClick={handleBack}
                      startIcon={<Icon>arrow_back</Icon>}
                      sx={{ mb: 0 }}
                    >
                      Back to Exams
                    </MDButton>
                  )}
                </MDBox>

                <MDBox p={1}>{renderContent()}</MDBox>
              </Card>
            </Grid>
          </Grid>
        )}
      </MDBox>
      <MDBox display="flex" flexDirection="column" minHeight="50vh"></MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Exams;
